module.exports = __webpack_public_path__ + "img/ledger-live-setting-step-nine.017c28ec.png";